import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const MapSectionContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '80px 0',
  backgroundColor: '#f8f9fa'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '36px',
  fontWeight: 700,
  color: '#121927',
  textAlign: 'center',
  marginBottom: '16px'
}));

const SectionSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  color: '#666',
  textAlign: 'center',
  marginBottom: '48px',
  maxWidth: '600px',
  margin: '0 auto 48px'
}));

const MapContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '450px',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  '& iframe': {
    width: '100%',
    height: '100%',
    border: 0
  }
}));

const MapSection = ({ location }) => {
  const {
    title = "Find Us",
    subtitle = "Visit our location or reach out to us for more information",
    address = "8819 Ohio St. South Gate, CA 90280",
    lat,
    lng
  } = location || {};

  const getMapSrc = () => {
    if (lat && lng) {
      return `https://maps.google.com/maps?q=${lat},${lng}&hl=en&z=14&output=embed`;
    }
    const encodedAddress = encodeURIComponent(address);
    return `https://maps.google.com/maps?q=${encodedAddress}&hl=en&z=14&output=embed`;
  };

  return (
    <MapSectionContainer>
      <Container maxWidth="lg">
        <SectionTitle>{title}</SectionTitle>
        <SectionSubtitle>{subtitle}</SectionSubtitle>
        <MapContainer>
          <iframe
            src={getMapSrc()}
            title="Business Location"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </MapContainer>
      </Container>
    </MapSectionContainer>
  );
};

export default MapSection;
